var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "tr0xpudu4a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EB758",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EB7A6",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12zm0-22.08c5.558 0 10.08 4.522 10.08 10.08S17.558 22.08 12 22.08 1.92 17.558 1.92 12 6.442 1.92 12 1.92zm4.35 7.96H13.44c.204-.358.306-.766.357-1.226.205-1.175-.715-2.197-1.89-2.197H11.6a.44.44 0 0 0-.41.409v1.226c0 .97-.51 1.89-1.378 2.401v6.386l.408.306c.307.205.664.358 1.022.358h4.495c.869 0 1.584-.613 1.686-1.43l.664-4.24c.205-1.022-.51-1.993-1.737-1.993zm-9.706 7.305h1.328a.786.786 0 0 0 .767-.766v-5.21a.786.786 0 0 0-.767-.767H6.644a.786.786 0 0 0-.766.766v5.21c0 .41.358.767.766.767z",
    fill: "url(#tr0xpudu4a)",
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.0c499ca2429801337ab38aaf18a0dbf6.svg";
export { ForwardRef as ReactComponent };